/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface WorkflowField { 
    id?: string;
    label?: string;
    field_type_id?: string;
    place_holder?: string;
    default_data?: string;
    api_url?: string;
    code?: string;
    required?: boolean;
    disabled?: boolean;
    formular?: string;
    class_name?: string;
    style?: string;
    description?: string;
    max_length?: number;
    min_length?: number;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    option_collection?: string;
    workflow_id?: string;
    table_excel_physical_path?: string;
    table_config_json?: string;
    table_excel_file_name?: string;
}